import React from 'react'
import Talles from '../../../Images/ger.jpg';
import Style from './General.module.css';

function Ger() {

    return (
        <div>
            <a href="https://www.academia.edu/20602832/Marguerite_Yourcenar_Mem%C3%B3rias_de_Adriano"><img src={Talles} className={Style.sizeImg} /></a>
        </div>
    )
}

export default Ger;